<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" *ngIf="editable" (click)="submit()">Zapisz i wyjdź</button>
	<button class="btn btn-primary me-3" *ngIf="!editable" (click)="editUnlock()">Edycja</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a></app-navbar
>
<div class="container my-4">
	<form (submit)="submit()">
		<fieldset>
			<div class="mb-3">
				<ng-select
					id="productKind"
					name="productKind"
					class="custom-ng-select"
					[(ngModel)]="defaultProductKind"
					placeholder="Rodzaj produktu"
					[disabled]="true"
					required
				>
					<ng-option *ngFor="let item of productKinds" [value]="item.id">
						{{ item.name }} | {{ item.code }}
					</ng-option>
				</ng-select>
			</div>
			<div class="mb-3">
				<ng-select
					id="Header"
					name="Header"
					class="custom-ng-select"
					[(ngModel)]="data.descriptionHeader.id"
					placeholder="Nagłówk opisu"
					[disabled]="!editHeader"
					required
				>
					<ng-option *ngFor="let item of descriptionHeaders" [value]="item.id">
						{{ item.name }}
					</ng-option>
				</ng-select>
			</div>

			<div class="mb-3 flex-forms-toggle">
				<mat-slide-toggle
					id="isRequired"
					name="isRequired"
					[(ngModel)]="data.isRequired"
					[disabled]="!editable"
					color="primary"
				>
					Wymagany do opublikowania oferty</mat-slide-toggle
				>
			</div>
		</fieldset>
	</form>
</div>
